import { render, staticRenderFns } from "./AutoPromoModal.vue?vue&type=template&id=73bc8277"
import script from "./AutoPromoModal.vue?vue&type=script&lang=js"
export * from "./AutoPromoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports